export enum WEEK_DAYS_ENUM {
  Mo = 'Mo',
  Tu = 'Tu',
  We = 'We',
  Th = 'Th',
  Fr = 'Fr',
  Sa = 'Sa',
  Su = 'Su',
}

export const WEEK_DAYS = {
  [WEEK_DAYS_ENUM.Mo]: 'Пн',
  [WEEK_DAYS_ENUM.Tu]: 'Вт',
  [WEEK_DAYS_ENUM.We]: 'Ср',
  [WEEK_DAYS_ENUM.Th]: 'Чт',
  [WEEK_DAYS_ENUM.Fr]: 'Пт',
  [WEEK_DAYS_ENUM.Sa]: 'Сб',
  [WEEK_DAYS_ENUM.Su]: 'Вс',
}

export type TWeekDaysValues = typeof WEEK_DAYS[keyof typeof WEEK_DAYS]
export type TWeekDaysKeys = keyof typeof WEEK_DAYS
